import { request } from '@/common'
// 获取隐私协议
export function getPhpProtocol(params: any) {
  return request.post('proxy-h5/php', 'api/sysstatic/getonepagenew', { params })
}
// 估值分析
export function getIndividualInfo(
  stockCode: string,
  market: string,
  valuationYears?: number
): Promise<any> {
  return request.get('proxy-h5/java', 'fxc-account/newsapi/information/valuation', {
    params: {
      stockCode,
      market,
      valuationYears,
    },
  })
}

// 提交认证方式 2活体（单开理财） 1单向 0双向
export function commitWitnessWay(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness-way', { params })
}
// 顺序：人像识别、正面照上传、公安认证、人脸识别/api/witness/live-detection/all
export function liveDetectionAll(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/live-detection/all', { params })
}
// 公安认证
export function idCheckGa(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/id-check-ga', { params })
}
// 上传正面照
export function uploadFace(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/upload-face', { params })
}
// 人脸识别结果提交
export function liveCommit(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/live-detection-commit', { params })
}
// 获取验证码
export function getVerifyCode(params: any) {
  console.log('12121', request)

  return request.post('proxy-h5/java', 'fxc-account/api/user/send-verify-code', { params })
}

// 登录
export function login(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/user/quick-login', { params })
}
//一键登录/user/api/quickLogin
export function auroraLogin(params: any) {
  return request.post('proxy-h5/java', 'user/api/quickLogin', { params })
}

//检查用户手机号或身份证是否为证券从业人员
export function searchUserPhone(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/open-limit/search', { params })
}

//客户号绑定状态查询
export function searchUserNumber(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/custId/search', { params })
}

//A03 投资大师开户入口
export function entrance(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/entrance', { params })
}

//A04、获取客户开户进度，每一步完成情况(501968)
export function getOpenUserStep(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/open/step/search', { params })
}

//A05、上传身份证照片，ocr识别后返回身份信息(501525)
export function getOCRIdCard(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/ocr/idcardV2', { params })
}
//05、上传身份证照片，ocr识别后返回身份信息(只识别，不验证，不保存)
export function getOCRIdCardInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/ocr/idcard-info', { params })
}
//A06 | A07、身份证图片信息提交，并修改上传身份证步骤完成状态，更新投资大师用户开户进度(501569)(PHP)
export function commitIdcard(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/commit-idcard', { params })
}

//A08、根据姓名或者手机号匹配经纪人
export function getBroker(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/broker/search', { params })
}

//A09、根据地址获取邮编(501557)
export function getPostId(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/post-id/search', { params })
}

//A10 | A11 | A12 | A13、(待定)获取数据字典和基本信息(501501)
export function getEnums(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/static/search', { params })
}

//A14、获取协议(501558)
export function getProtocol(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/protocol/search', { params })
}

//A14-1、获取协议详情(501558)
export function getProtocolDetail(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/protocol/detail', { params })
}

//A14-2、获取协议列表(501558)
export function getProtocolList(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/protocol/list', { params })
}
//A15、签署电子协议，在非现场记录(501554)
export function signProtocol(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/sign-protocol', { params })
}

//A17、查询身份证号是否存在其他开户记录，如果存在，查询完成流程最多的记录(501970)
export function getOpenUser(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/open-record/search', { params })
}

//A18 | A19、(待定)客户身份信息确认，保存客户修改后的信息，开户保存证件信息(501528)(PHP)
export function saveUserInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/save-complete-info', { params })
}

//A20、根据customerId作废老流程 （501972）
export function cancelOldProgress(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/flow/disuse', { params })
}

//A21、继续同步开户流程，更新为新手机号（501971）选择新流程
export function useNewProgress(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/flow/synchronize', { params })
}

//A22、问卷测评 （501539）风险测评题库
export function getRiskPaper(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/risk/subjects', { params })
}

//A23 问卷回访 (501541)
export function getVisitPaper(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/visit/subjects', { params })
}
//A24 自动回答问题 年龄和教育 默认答案
export function getDefaultAnswer(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/auto/answer', { params })
}

//A25 提交问卷 返回评测等级
export function submitRiskPaper(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/risk/commit', { params })
}

//A25-1 提交风险测评进度及协议
export function commitRiskStep(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/risk-protocol/commit', { params })
}

//A26 保存开户状态 更新渠道信息
export function saveProgress(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/saveProgress', { params })
}

//A27 获取风险等级
export function getRiskList(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/riskList', { params })
}

//A28 获取开户列表
export function getOpenList(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/openList', { params })
}

//A29 获取公玥
export function getRsa(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/rsa/public-key', { params })
}

//A30 开户初始化资金账户/转户 保存转户信息 更新流程
export function initOpen(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/init', { params })
}
//A33 根据银行卡前缀获取我们本地对应的银行卡code
export function getBankCode(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/bank/bankcode', { params })
}
//A34、获取银行列表
export function getBankList(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/bank/bank-list/search', { params })
}

//A35|A36、存管银行绑定
export function bindBank(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/bank/bank-bind', { params })
}

//A37、修改客户视频见证方式
export function updateVideotype(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness-way', { params })
}

//A38、人脸比对
export function facecComparison(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/face-comparison', { params })
}

//A39、单向视频提交
export function submitSingleVideo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/single-commit', { params })
}

//A40、修改流程状态到待初审
export function updateFirstStep(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/progress/modify-first-state', { params })
}

//A41、查询转户信息
export function getChangeAccount(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/progress/queryopenchange', { params })
}

//A42、查询开户状态
export function getOpenAccountStatus(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/progress/openprogress', { params })
}

//A43、获取电话号码
export function getCallNumber(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/call-number/search', { params })
}

//A46|A47、回访问卷答案提交
export function submitVisitPaper(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/survey/question/submit', { params })
}

//A48、视频见证排队
export function waitVideo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/queue', { params })
}

//A49、当前客户排队的队列位置
export function getWaitIndex(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/queue-index', { params })
}

//A50、客户轮询自己是否被选中
export function pollSelectSelf(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/selected', { params })
}

//A51、客户退出排队队列
export function quitWaitVideo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/quit', { params })
}

//A52、查询服务的服务器地址端口房间号等信息
export function getIpRoom(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/room/query', { params })
}

//A53、客户离开房间，挂断视频连接
export function hangUpVideo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/hang-up', { params })
}

//A54、查询视频通过状态
export function getVideoPassStatus(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/status', { params })
}

//A55、更新投资大师用户开户进度
export function updateprogress(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/progress/updateprogress', { params })
}

//A56、获取已答题目结果信息
export function getAnswers(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/risk/answer/query', { params })
}

//A57、获取开户进度百分比
export function getOpenPersent(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/progress/percent', { params })
}

//A60、获取佣金协议
export function getAgreementProtocol(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/agreement/commission', { params })
}

//A61、获取佣金协议
export function getChannelRateProtocol(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/channel-info/search', { params })
}

//A62、保存渠道佣金信息
export function saveChannelRateInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/channel/commission/log', { params })
}
//A63、根据姓名或者手机号匹配经纪人
export function searchbrokerpaged(params: any) {
  return request.post('proxy-h5/java', '/fxc-account/api/account/broker/search', { params })
}

//A65、获取客户推荐人信息或者经纪人信息(PHP)
export function getBrokerInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/get-recommend-info', { params })
}

//获取鑫理财经纪关系，弃用api/account/get-recommend-info接口
export function getXlcBrokerInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/broker/searchV2', { params })
}

//A66、查询双向视频席位
export function checkSeat(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/witness/seat/check', { params })
}
//A67、获取身份证图片
export function getIdPhoto(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/search-idcard-image', { params })
}
//A68、驳回状态恢复设置
export function reject(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/reject/recovery', { params })
}
//A69、保存人脸比对照片
export function saveFaceImg(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/save-rlbd-img', { params })
}
//A70、查看保存开户和银行信息
export function saveList(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/saveList', { params })
}
// A71、获取服务器时间戳
export function getAccounTime(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/time', { params })
}

// A72、查询分支机构
export function getRoleList(params?: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/role/roleList', { params })
}

// A73、检查用户绑定的推荐人与扫码推荐人是否一致
export function checkRecommand(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/recommend/check', { params })
}

// A74：用户根据手机号查询当前的审核状态
export function checkUserStep(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/userstep/check', { params })
}

export function uploadVideo(headers: any, params: any) {
  return request.postForm('proxy-h5/upload-file', 'api/upload/base64', { headers, params })
}
// export function tttt(params: any) {
//   return request.post('proxy-h5/java', 'keepalived/t', { params })
// }
//推荐人绑定
export function clientPerson(params: any) {
  return request.post('proxy-h5/java', 'activity-managent/api/client/personnel', { params })
}
// 统计次数
export function clientStatisticsData(params: any): Promise<any> {
  return request.post('proxy-h5/java', 'activity-managent/api/client/statisticsData', { params })
}
// 获取协议
export function getWxConfig(params: any): Promise<any> {
  return request.post('proxy-h5/php', 'api/warehouse/get-message', {
    params,
  })
}

/**
 * 覆盖来源
 * @param params
 * @returns
 */
export function editCompany(params: any): Promise<any> {
  return request.post('proxy-h5/java', 'fxc-account/api/company/edit', {
    params,
  })
}

/**
 * 保存开户用户和渠道信息接口
 * @param params
 * @returns
 */
export function saveCompany(params: any): Promise<any> {
  return request.post('proxy-h5/java', 'fxc-account/api/khchannel/save-user-channel', {
    params,
  })
}

export function checkPoliceUserInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/check-police-userinfo', {
    params,
  })
}

// 获取地址
export function address() {
  return request.post('proxy-h5/java', 'fxc-account/api/account/address/search', {})
}

export function checkIdcardDate(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/check-idcardDate', {
    params,
  })
}

export function getChannelInfo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/khchannel/get-channel-info', {
    params,
  })
}

export function openProgress(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/openProgress', { params })
}

export function disuse(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/ths/disuser', { params })
}

export function queryIsbankpwd(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/bank/query-isbankpwd', { params })
}

export function checkBlack(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/account/checkBlack', { params })
}

export function isMakeVideo(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/fund/account/isMakeVideo', { params })
}

export function getKeyValue(params: any) {
  return request.post('proxy-h5/java', 'fxc-account/api/business/get-key-value', { params })
}
